import { FlexRow } from '@make-software/cspr-design';
import styled from 'styled-components';

export const Divider = styled.div(({ theme }) => ({
  width: '100%',
  height: 1,
  background: theme.styleguideColors.borderPrimary,
  margin: '0',
}));

export const PaymentAmountContainer = styled(FlexRow)(() => ({
  height: '20px',
}));
